import * as t from  './actionTypes';
import * as api from './api';

// load existing data
export function loadData() {
  return (dispatch) => {
    dispatch({ type: t.SET_BUSY });
    api.getData((success, data, error) => {
      if (success) {
        dispatch({ type: t.DATA_LOAD_SUCCESS, data: data });
        dispatch({ type: t.UNSET_BUSY });
      } else if (error) {
        dispatch({ type: t.UNSET_BUSY });
      }
    });
  }
}

// create new data
export function createNewData(data, successCB, errorCB) {
  return (dispatch) => {
    dispatch({ type: t.SET_BUSY });
    api.createNewData(data, function(success, data, error) {
      if (success) {
        dispatch({ type: t.DATA_CREATE_SUCCESS, data: data });
        dispatch({ type: t.UNSET_BUSY });
        successCB();
      } else if (error) {
        dispatch({ type: t.UNSET_BUSY });
        errorCB(error);
      }
    })
  }
}

// edit existing data
export function editData(id, data, successCB, errorCB) {
  return (dispatch) => {
    dispatch({ type: t.SET_BUSY });
    api.editData(id, data, function(success, data, error) {
      if (success) {
        dispatch({ type: t.DATA_EDIT_SUCCESS, id: id, data: data });
        dispatch({ type: t.UNSET_BUSY });
        successCB();
      } else if (error) {
        dispatch({ type: t.UNSET_BUSY });
        errorCB(error);
      }
    })
  }
}

// delete existing data
export function deleteData(id, successCB, errorCB) {
  return (dispatch) => {
    dispatch({ type: t.SET_BUSY });
    api.deleteData(id, function(success, error) {
      if (success) {
        dispatch({ type: t.DATA_DELETE_SUCCESS, id: id });
        dispatch({ type: t.UNSET_BUSY });
        successCB();
      } else if (error) {
        dispatch({ type: t.UNSET_BUSY });
        errorCB(error);
      }
    })
  }
}
